export const ROLES = {
  ADMIN: 1,
  USER: 3,
  MODERATOR: 2,
};
